import captionService from 'CaptionService';

export const choose = {
	cancel: () => captionService.getString('05186971-06d4-4a9f-9f2c-76163ad2e67a', 'None of the above'),
	select: () => captionService.getString('b4ce975a-9afd-45c9-954d-ccd68eb1d79b', 'Select'),
};
